export default {
	familyGroupId: '',
	familyKinshipId: '',
	familyGroupKindship: '',
	personId: '',
	identificationTypeId: '',
	familyGroupName: '',
	familyGroupIdentification: '',
	familyGroupAddress: '',
	familyGroupPhone: '',
	familyGroupEmail: '',
	familyGroupOccupation: '',
	familyGroupBirthdate: '',
	familyGroupGender: '',
	familyGroupIsCompensationBoxSubsidy: false
}
